export const gaProperty = 'G-JPGZTCLXEQ';
export const baseApiUrl = window.appConfig?.baseApiUrl || console.error('ERROR, no global appConfig provided. App cannot work.');
export const storeKeyPrefix = 'begolf-';
export const questionsStoreKeyPrefix = storeKeyPrefix + 'questions-progress';
export const userProgressStoreKey = storeKeyPrefix + 'user-progress';
export const loginStoreKey = storeKeyPrefix + 'login';
export const skipIntroStoreKey = storeKeyPrefix + 'skip-intro';
export const demoSetupStoreKey = storeKeyPrefix + 'demo-setup';
export const allowedWrongAnswersPerChapter = 1;